import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFileAutodeletion = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 21,
	viewBox: "0 0 19 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.86629 20H4.80976C3.80194 20 2.83539 19.5996 2.12276 18.887C1.41011 18.1743 1.00977 17.2078 1.00977 16.2V13.2455C1.00977 9.99773 2.2999 6.88309 4.59638 4.58662C6.89286 2.29015 10.0075 1 13.2553 1H14.3098C15.3175 1 16.2842 1.40035 16.9968 2.11299C17.7094 2.82563 18.1098 3.79217 18.1098 4.8V9.9679",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 13.407C1 8.505 6.22503 12.4569 9.29349 9.3789C12.362 6.30095 8.43849 1 13.331 1",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 7L16 4",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 4L16 7",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.031 20.0619C16.2572 20.0619 18.0619 18.2572 18.0619 16.031C18.0619 13.8047 16.2572 12 14.031 12C11.8047 12 10 13.8047 10 16.031C10 18.2572 11.8047 20.0619 14.031 20.0619Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0293 13.3438V16.0311",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9354 17.9374L14.0293 16.0312",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconFileAutodeletion;
